const base = {
    devPath: "http://47.111.96.11:8083/",
    proPath: "http://47.111.96.11:8083/",
    imgPath: "http://47.111.96.11:8084/",
}

export default base
